import axios from 'axios'

// eslint-disable-next-line import/no-default-export
export default {
  getParcel(trackingCode, verification) {
    return axios.get(`/api/track/${trackingCode}/${verification}`).then((resp) => resp.data)
  },
}
